import React from 'react';
import css from './MyDigiFlat.module.scss';
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";
import wct from "../../../assets/images/extra/logowct.png";
import ord from "../../../assets/images/extra/logoord.png";
import angular from "../../../assets/images/extra/angular.png";
import java from "../../../assets/images/extra/java-coffee-cup-logo.png";
import springBoot from "../../../assets/images/extra/springBoot.png";
import couchBase from "../../../assets/images/extra/couchBase.png";
import svn from "../../../assets/images/extra/svn.png";
import talend from "../../../assets/images/extra/talend.png";
import jenkins from "../../../assets/images/extra/jenkins.png";
import myFlat from "../../../assets/images/projectsImage/myFlat.jpg";

const MyDigiFlat: React.FC = () => (
    <div className={css.project} id="myDigiFlat">
        <img src={myFlat} alt=""/>
        <div className={css.projectInformationContainer}>

            <div className={css.projectName} style={{position: 'relative'}}>
                <h3>MyDigiFlat</h3>
                <Tooltip title="Host Company">
                    <img src={wct} width={52} height={25}
                         onClick={() => window.open('http://whitecapetech.com/',
                             "_blank")}
                         style={{marginLeft: '1em', position: 'absolute', right: 35, cursor: 'pointer'}}
                         alt=""/>
                </Tooltip>
                <Tooltip title="Client">
                    <img src={ord} width={25} height={25}
                         onClick={() => window.open('https://ordiges.com/en/',
                             "_blank")}
                         style={{marginLeft: '1em', position: 'absolute', right: 0, cursor: 'pointer'}}
                         alt=""/>
                </Tooltip>
            </div>

            <div className={css.infoSmallScreen}>
                <Chip label="Jul. 2019 - Jul. 2020" size='small' variant="outlined"/>
            </div>
            <div className={css.info}>
                <Chip label="Jul. 2019 - Jul. 2020" size='small' variant="outlined"/>
            </div>

            <h5 className={css.textSectionInfo}>Description:</h5>
            <p className={css.description}>
                It's a friendly web application designed to optimise the relationship between social housing
                authorities and their tenants.
            </p>
            <p className={css.description}>
                In another world, it's a solution to help tenants manage their rented property and automatize some process.
            </p>
            <div className={css.learnMoreLink}>
                <p>Learn more: <a className={css.link}
                                  href='https://ordiges.com/en/it-solutions-business-performance/mydigiflat-web-digital-social-housing/'
                                  rel="noopener noreferrer"
                                  target="_blank">Here!</a>
                </p>
            </div>

            <h5 className={css.textSectionInfo}>Tasks:</h5>
            <ul className={css.tasks}>
                <li>Injected Couchbase with data extracted from Oracle and MsSql databases. (Talend ESB)
                </li>
                <li>Optimised Rest API (gained 60% internet cost / processing time). (SpringBoot, Angular)
                </li>
                <li>Implemented push web application mechanism to receive real-time notifications.
                    (Angular)
                </li>
                <li>Participated in designing and developing dynamic forms. (Angular)</li>
                <li>Design and implement features.</li>
            </ul>

            <h5 className={css.textSectionInfo}>Keywords:</h5>
            <div className={css.keywords} style={{marginTop: 10}}>
                <Tooltip title="Push Web Notification">
                    <Chip label="PWA" color="primary" variant="outlined" size='small'/>
                </Tooltip>
                <Tooltip title="Architecture Micro-Services">
                    <Chip label="Micro-Services" color="primary" variant="outlined" size='small'/>
                </Tooltip>
                <Tooltip title="All forms in the application are fully customizable">
                    <Chip label="Dynamic-Forms" color="primary" variant="outlined" size='small'/>
                </Tooltip>
                <Tooltip title="Methodology Scrum">
                    <Chip label="Scrum" color="primary" variant="outlined" size='small'/>
                </Tooltip>
                <Tooltip title="Json Web Token">
                    <Chip label="JWT" color="primary" variant="outlined" size='small'/>
                </Tooltip>
            </div>
            <div className={css.keywords}>
                <Tooltip title="Angular">
                    <img src={angular} alt=""/>
                </Tooltip>
                <Tooltip title="Java">
                    <img src={java} alt=''/>
                </Tooltip>
                <Tooltip title="Spring Boot">
                    <img src={springBoot} alt=''/>
                </Tooltip>
                <Tooltip title="CouchBase">
                    <img src={couchBase} alt=""/>
                </Tooltip>
                <Tooltip title="SVN">
                    <img src={svn} alt=""/>
                </Tooltip>
                <Tooltip title="Talend ESB">
                    <img src={talend} alt=""/>
                </Tooltip>
                <Tooltip title="Jenkins">
                    <img src={jenkins} alt=""/>
                </Tooltip>
            </div>
        </div>
    </div>
);

export default MyDigiFlat;
